import React from 'react';
import { Route } from 'react-router-dom';
import CreateUserPage from '../../DetailsUplode/CreateUserPage.js';
import CreateAdminPage from '../../DetailsUplode/CreateAdminPage.js';
import CacheSettings from '../../ListPages/Cachesettings.js';
import AdminSetupGuidePage from '../../AdminGuide/AdminSetupGuidePage.js';
import { guardRoute } from '../ProtectedRoute.js';

export const loginAndAccessRoutes = [
  <Route key="create-user" path="/create-user" element={guardRoute(<CreateUserPage />, '/create-user')} />,
  <Route
    key="create-admin"
    path="/create-admin"
    element={guardRoute(<CreateAdminPage />, '/create-admin')}
  />,
  <Route
    key="admin-setup-guide"
    path="/admin-setup-guide"
    element={guardRoute(<AdminSetupGuidePage />, '/admin-setup-guide')}
  />,
  <Route
    key="cache-settings"
    path="/CacheSettings"
    element={guardRoute(<CacheSettings />, '/CacheSettings')}
  />,
];
